import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import Filter from '../../../components/Filter/Filter';
import { FirstFilterLine, PaginationH5, SecondFilterLine } from '../../../components/Filter/Filter.styles';
import DateInput from '../../../components/DateInput';
import SelectOptions from '../../../components/SelectOptions';
import Button from '../../../components/Button/Button';
import { ImSearch } from 'react-icons/im';
import { LoadingContainer } from '../../GerenciarClientes/styles/GerenciarClientes.styles';
import { CircularProgress } from '@material-ui/core';
import Table from '../../../components/Table/Table';
import formatCPF from '../../../utils/functions/formatCPF';
import formatCNPJ from '../../../utils/functions/formatCNPJ';
import useCallFilter from '../../../utils/hooks/useCallFilter';
import { useTheme } from 'styled-components';
import moment from 'moment';
import {
  pixRefundDetailsFetchActions,
  pixRefundFetchActions,
  pixRefundTypeParticipantsFetchActions,
  pixRefundTypeStatusFetchActions,
} from '../../../store/fetchActions/pixRefundActions';
import { Box, Grid } from '@mui/material';
import formatMoney from '../../../utils/functions/formatMoneyBRL';
import ModalPixRefund from '../components/Modal/ModalPixRefund';
import StatusContainer from '../../../components/StatusContainer/StatusContainer';

const PayerAndReceiverGridInfo = (name, documentId) => (
  <Grid container>
    <Grid item xs={12}>
      {name.length > 0 ? name : '----'}
    </Grid>
    <Grid item xs={12}>
      {documentId.length > 11 ? formatCNPJ(documentId) : formatCPF(documentId)}
    </Grid>
  </Grid>
);

const PixRefund = () => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const [filterData, setFilterData] = useState('');
  const [isModalDetailsOpen, setIsModalDetailsOpen] = useState(false);
  const [filter, setFilter] = useState({
    PAGE: 1,
    LIMITE: 100,
    PAGE_SIZE: 25,
    PARTICIPANTE: 1,
    STATUS: 1,
    DETALHES: '',
    MODIFICADO_DEPOIS: '',
    MODIFICADO_ANTES: '',
  });
  const [dateInicial, setDateInicial] = useState(null);
  const [dateFinal, setDateFinal] = useState(moment().format('YYYY-MM-DD'));

  const { handleSubmit, control, setValue } = useForm({
    defaultValues: {
      ...filter,
    },
  });


  const {
    dataPixRefund,
    loadingPixRefund,
    errorLoadingPixRefund,
    paginationPixRefund,
    errorMessagePixRefund,
    detailsPixRefund,
    typeParticipants,
    typeStatusRefund,
  } = useSelector((state) => state.pixRefund);

  const filterTable = (data) => {
    data = {
      ...filter,
      PAGE: data?.PAGE,
      MODIFICADO_DEPOIS: dateInicial,
      MODIFICADO_ANTES: dateFinal,
      PARTICIPANTE: data?.tipoParticipante,
      STATUS: data?.tipoStatus,
      DETALHES: data?.detalhes,
      PAGE_SIZE: data?.pageSize,
    };
    setFilterData(data);
  };

  useCallFilter(filterData, setFilter, pixRefundFetchActions, 0, 0);

  useEffect(() => {
    dispatch(pixRefundFetchActions(filter));
  }, [filter.PAGE]);

  useEffect(() => {
    setValue('tipoParticipante', 1);
    dispatch(pixRefundTypeParticipantsFetchActions());
    dispatch(pixRefundTypeStatusFetchActions());
  }, []);

  const arrayParticipants = typeParticipants.map((key) => {
    return {
      ID: key.id,
      NOME: key.description,
    };
  });

  const handleShowModalDetails = (id) => {
    setIsModalDetailsOpen(true);
    dispatch(pixRefundDetailsFetchActions(id));
  };

  const arrayStatusRefund = typeStatusRefund.map((key) => {
    return {
      ID: key.id,
      NOME: key.description,
    };
  });

  const pageOptions = [
    { ID: 25, NOME: 25 },
    { ID: 50, NOME: 50 },
    { ID: 100, NOME: 100 },
  ];

  const body = dataPixRefund?.map((key) => {
    return {
      data: [
        { info: key.creationtime, align: 'center' },
        { info: () => PayerAndReceiverGridInfo(key?.namePayer, key?.documentIdPayer), align: 'left' },
        { info: () => PayerAndReceiverGridInfo(key?.nameReceiver, key?.documentIdReceiver), align: 'left' },
        {
          info: key?.status ? (
            <StatusContainer code={key?.status} description={key?.status}></StatusContainer>
          ) : (
            '-----'
          ),
          align: 'center',
        },
        { info: 'R$' + formatMoney(key?.refundamount), align: 'right' },
        { info: key?.transactionid, align: 'center' },
      ],
      onClick: () => handleShowModalDetails(key?.id),
    };
  });

  const header = [
    {
      id: 'data de registro',
      name: 'DATA INSERÇÂO',
      align: 'center',
    },
    {
      id: 'payer',
      name: 'PAGADOR',
      align: 'left',
    },
    {
      id: 'receiver',
      name: 'RECEBEDOR',
      align: 'left',
    },
    {
      id: 'status',
      name: 'STATUS',
      align: 'center',
    },
    {
      id: 'value',
      name: 'VALOR',
      align: 'right',
    },
    {
      id: 'Numero operação',
      name: 'NÚMERO DA OPERAÇÃO',
      align: 'center',
    },
  ];

  return (
    <>
      <div>
        <Filter>
          <form onSubmit={handleSubmit(filterTable)}>
            <FirstFilterLine>
              <DateInput
                label="Data Inicial"
                name={'dataInicial'}
                control={control}
                value={dateInicial}
                onChange={(newValue) =>
                  newValue?.$d ? setDateInicial(moment(newValue?.$d).format('YYYY-MM-DD')) : setDateInicial(null)
                }
              />
              <DateInput
                label="Data Final"
                name={'dataFinal'}
                control={control}
                value={dateFinal}
                onChange={(newValue) =>
                  newValue?.$d ? setDateFinal(moment(newValue?.$d).format('YYYY-MM-DD')) : setDateFinal(null)
                }
              />
              <SelectOptions
                label="Tipo de Participante"
                name={'tipoParticipante'}
                width={'15.042vw'}
                control={control}
                options={arrayParticipants}
                initialValue={1}
              />
              <SelectOptions
                label="Status"
                name={'tipoStatus'}
                width={'15.042vw'}
                control={control}
                options={arrayStatusRefund}
                initialValue={1}
              />
              <Button
                backgroundcolor={theme.colors.buttonSearch}
                width={'16.042vw'}
                hoverbgcolor={theme.colors.buttonSearchHover}
                hovercolor={theme.colors.buttonSearchHoverText}
                mycolor={theme.colors.buttonSearchText}
                type="submit"
              >
                <ImSearch className="default-svg" size={'1.181vw'} />
                <span>Buscar</span>
              </Button>
            </FirstFilterLine>
            <SecondFilterLine>
              <h5>Resultados por Página</h5>
              <SelectOptions control={control} options={pageOptions} name={'pageSize'} initialValue={25} />
              <h5>Total de Registros: {paginationPixRefund?.totalRecords ?? 0}</h5>
            </SecondFilterLine>
          </form>
        </Filter>
        {loadingPixRefund ? (
          <LoadingContainer>
            <CircularProgress size={'5vw'} color="inherit" />
          </LoadingContainer>
        ) : (
          <Table
            loading={loadingPixRefund}
            error={errorLoadingPixRefund}
            hasPagination={true}
            filter={filter}
            pagination={paginationPixRefund}
            setFilter={setFilter}
            errorMessage={errorMessagePixRefund}
            filterTable={filterTable}
            body={body}
            header={header}
            limit={filter.PAGE_SIZE}
          />
        )}
        {isModalDetailsOpen && (
          <ModalPixRefund
            open={isModalDetailsOpen}
            close={() => setIsModalDetailsOpen(false)}
            data={detailsPixRefund}
          />
        )}
      </div>
    </>
  );
};

export default PixRefund;
